export default {
  defaultColor: 'black',
  defaultSize: 'small',
}
